<div class="login-page">
  <!-- Header with Language Selector -->
  <app-super-header></app-super-header>

  <!-- Decorative Floating Shapes -->
  <div class="floating-shape floating-shape-left"></div>
  <div class="floating-shape floating-shape-right"></div>

  <div class="login-container">
    <!-- Logo -->
    <div class="login-logo">
      <a routerLink="/login" routerLinkActive="true">
        <img src="assets/images/logo.png" alt="Logo" />
      </a>
    </div>

    <!-- Login Card -->
    <div class="login-card">
      <!-- Card Content -->
      <div class="card-content">
        <!-- Title -->
        <h2 class="login-title">{{'login.Signin' | translate}}</h2>

        <!-- Email Step -->
        @if (!ssoApiResponsecame) {
          <div class="login-form">
            <form [formGroup]="loginFirstForm" (keyup.enter)="getPiSSologinStatu()">
              <!-- Email Input -->
              <div class="form-group">
                <div class="input-wrapper">
                  <span class="input-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM16.8 6L10 10.78L3.2 6H16.8ZM2 14V6.91L9.68 12.25C9.77344 12.3172 9.88534 12.3531 10 12.3531C10.1147 12.3531 10.2266 12.3172 10.32 12.25L18 6.91V14H2Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <input
                    type="email"
                    name="email"
                    maxlength="50"
                    formControlName="email"
                    class="form-input"
                    placeholder="{{'dashboard.WorkEmail' | translate}}"
                    autocomplete="email"
                    />
                </div>
                @if (this.loginFirstForm.controls['email'].hasError('pattern') && (this.loginFirstForm.controls['email'].touched || this.loginFirstForm.controls['email'].dirty)) {
                  <div
                    class="error-text">
                    {{'login.pleaseenteravalidemail' | translate}}
                  </div>
                }
                @if (this.loginFirstForm.controls['email'].hasError('required') && (this.loginFirstForm.controls['email'].touched || this.loginFirstForm.controls['email'].dirty)) {
                  <div
                    class="error-text">
                    {{'login.thisfieldisrequired' | translate}}
                  </div>
                }
              </div>
              <!-- Data Consent Checkbox -->
              @if (this.dataConsentRequired === 'true' && this.dataConsentAlreadyAccepted !== 'true') {
                <div class="form-group">
                  <label class="checkbox-label">
                    <input
                      type="checkbox"
                      id="agreePolicy"
                      (change)="checkBoxChange($event.target.checked)"
                      [checked]="agreePolicy"
                      class="checkbox-input"
                      />
                    <span class="checkbox-custom"></span>
                    <span class="checkbox-text">{{'reset.IagreetodataprocessingintheUnitedStates' | translate}}</span>
                  </label>
                  @if (showError) {
                    <div class="error-text" style="margin-top: 8px;">
                      {{'reset.Pleaseaccepttheterms' | translate}}
                    </div>
                  }
                </div>
              }
              <!-- Continue Button -->
              @if (!this.loginService.isRequestInProgress) {
                <button
                  type="button"
                  (click)="getPiSSologinStatu()"
                  class="btn-primary">
                  {{'dashboard.Continue' | translate}}
                </button>
              }
              @if (this.loginService.isRequestInProgress) {
                <button
                  type="button"
                  class="btn-primary btn-loading">
                  <span class="loading-dots">
                    {{'profilePreference.PleaseWait' | translate}}
                    <loader-dots class="loader-inline"></loader-dots>
                  </span>
                </button>
              }
            </form>
          </div>
        }

        <!-- Password Step -->
        @if (ssoApiResponsecame) {
          <div class="login-form">
            <form [formGroup]="loginForm" (keyup.enter)="signInWithGallop()">
              <!-- Email Display (Read-only) -->
              <div class="form-group">
                <div class="input-wrapper input-readonly">
                  <span class="input-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM16.8 6L10 10.78L3.2 6H16.8ZM2 14V6.91L9.68 12.25C9.77344 12.3172 9.88534 12.3531 10 12.3531C10.1147 12.3531 10.2266 12.3172 10.32 12.25L18 6.91V14H2Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <input
                    type="email"
                    name="email"
                    maxlength="50"
                    formControlName="email"
                    class="form-input"
                    placeholder="{{'login.Email' | translate}}"
                    autocomplete="email"
                    readonly
                    />
                  <button type="button" class="change-link" (click)="changeEmail()">
                    {{'dashboard.Change' | translate}}
                  </button>
                </div>
              </div>
              <!-- Password Input -->
              <div class="form-group">
                <div class="input-wrapper input-with-toggle">
                  <span class="input-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.8333 9.16667H15V6.66667C15 3.44167 12.3917 0.833336 9.16667 0.833336C5.94167 0.833336 3.33333 3.44167 3.33333 6.66667V9.16667H2.5C1.58333 9.16667 0.833336 9.91667 0.833336 10.8333V17.5C0.833336 18.4167 1.58333 19.1667 2.5 19.1667H15.8333C16.75 19.1667 17.5 18.4167 17.5 17.5V10.8333C17.5 9.91667 16.75 9.16667 15.8333 9.16667ZM5.83333 6.66667C5.83333 4.83334 7.33333 3.33334 9.16667 3.33334C11 3.33334 12.5 4.83334 12.5 6.66667V9.16667H5.83333V6.66667ZM15.8333 17.5H2.5V10.8333H15.8333V17.5ZM9.16667 15C10.0833 15 10.8333 14.25 10.8333 13.3333C10.8333 12.4167 10.0833 11.6667 9.16667 11.6667C8.25 11.6667 7.5 12.4167 7.5 13.3333C7.5 14.25 8.25 15 9.16667 15Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    id="login_password"
                    maxlength="20"
                    formControlName="password"
                    class="form-input"
                    placeholder="{{'login.Password' | translate}}"
                    autocomplete="current-password"
                    />
                  <button
                    type="button"
                    class="password-toggle"
                    (click)="togglePasswordVisibility()"
                    (keyup)="$event.stopPropagation()"
                    [attr.aria-label]="(showPassword ? 'login.Hidepassword' : 'login.Showpassword') | translate"
                    [attr.aria-pressed]="showPassword"
                    title="{{(showPassword ? 'login.Hidepassword' : 'login.Showpassword') | translate}}">
                    @if (!showPassword) {
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    } @else {
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    }
                  </button>
                </div>
                @if (loginForm.controls['password'].hasError('required') && (loginForm.controls['password'].touched || loginForm.controls['password'].dirty)) {
                  <div
                    class="error-text">
                    {{'login.thisfieldisrequired' | translate}}
                  </div>
                }
              </div>
              <!-- Forgot Password -->
              <div class="forgot-password">
                <a (click)="goToRequestResetPassword(createPasswordModal)" class="forgot-link">
                  {{'login.Forgotpassword' | translate}}
                </a>
              </div>
              <!-- Sign In Button -->
              @if (!this.loginService.isRequestInProgress) {
                <button
                  type="button"
                  (click)="signInWithGallop()"
                  class="btn-primary">
                  {{'login.Signin' | translate}}
                </button>
              }
              @if (this.loginService.isRequestInProgress) {
                <button
                  type="button"
                  class="btn-primary btn-loading">
                  <span class="loading-dots">
                    {{'profilePreference.PleaseWait' | translate}}
                    <loader-dots class="loader-inline"></loader-dots>
                  </span>
                </button>
              }
              <!-- Social Login Buttons -->
              @if (socialLoginsSupported) {
                <div class="social-login-section">
                  <div class="divider">
                    <span>{{'login.Or' | translate}}</span>
                  </div>
                  <button
                    type="button"
                    class="btn-social"
                    (click)="handleGoogleSignInCLick(azureOpen)">
                    <img src="assets/images/google-icon.png" alt="Google" />
                    <span>{{'login.SigninwithGoogle' | translate}}</span>
                  </button>
                  <button
                    type="button"
                    class="btn-social"
                    (click)="handleMSALClick(azureOpen)">
                    <img src="assets/images/microsoft-logo.png" alt="Microsoft" />
                    <span>{{'login.SigninwithMicrosoft' | translate}}</span>
                  </button>
                  @if (this.ssoPolicy ==='optional') {
                    <button
                      type="button"
                      class="btn-social"
                      (click)="signWithSSo()">
                      <span>{{'dashboard.SigninwithSSo' | translate}}</span>
                    </button>
                  }
                </div>
              }
            </form>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Keep existing modals unchanged -->
<ng-template #createAccountModal let-modal>
  <div class="modal-header" style="background-color: #fcfcfc;">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="header1-inner">
          <div class="header-left">
            <div class="logo">
              <a href="javascript:void(0)">
                <img src="assets/images/logo.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="close" data-dismiss="modal" (click)="onModelCancel()">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="form-header" style="background-color: #fcfcfc;">
    <h2>{{'login.SignUp' | translate}}</h2>
  </div>
  <div class="form-data" style="background-color: #fcfcfc;padding-bottom:32px;">
    <form [formGroup]="signUpForm">
      <input type="hidden" id="profileImageUrl" name="profileImageUrl" />
      <input type="hidden" id="googleAccessToken" name="googleAccessToken" />
      <label></label>
      <div class="input-box input-box-with-icon">
        <input type="text" formControlName="firstName" placeholder="{{'login.Firstname' | translate}}" />
        <span class="input-box-icon-container">
          <img class="input-box-icon" src="assets/images/user.png" alt="" />
        </span>
        @if (signUpForm.controls['firstName'].hasError('required') && (signUpForm.controls['firstName'].touched || signUpForm.controls['firstName'].dirty)) {
          <div
            class="error">{{'login.thisfieldisrequired' | translate}}
          </div>
        }
        @if (signUpForm.controls['firstName'].hasError('pattern') && (signUpForm.controls['firstName'].touched || signUpForm.controls['firstName'].dirty)) {
          <div
            class="error">{{'login.pleaseentervalidfirstname' | translate}}
          </div>
        }
      </div>
      <div class="input-box input-box-with-icon">
        <input type="text" formControlName="lastName" placeholder="{{'login.Lastname' | translate}}" />
        <span class="input-box-icon-container">
          <img class="input-box-icon" src="assets/images/user.png" alt="" />
        </span>
        @if (signUpForm.controls['lastName'].hasError('required') && (signUpForm.controls['lastName'].touched || signUpForm.controls['lastName'].dirty)) {
          <div
            class="error">{{'login.thisfieldisrequired' | translate}}
          </div>
        }
        @if (signUpForm.controls['lastName'].hasError('pattern') && (signUpForm.controls['lastName'].touched || signUpForm.controls['lastName'].dirty)) {
          <div
            class="error">{{'login.pleaseentervalidlastname' | translate}}
          </div>
        }
      </div>
      <div class="input-box input-box-with-icon">
        <input type="text" formControlName="email" placeholder="{{'login.Email' | translate}}" />
        <span class="input-box-icon-container">
          <img class="input-box-icon" src="assets/images/mail.png" alt="" />
        </span>
        @if (signUpForm.controls['email'].hasError('pattern') && (signUpForm.controls['email'].touched || signUpForm.controls['email'].dirty)) {
          <div
            class="error">{{'login.pleaseenteravalidemail' | translate}}
          </div>
        }
        @if (signUpForm.controls['email'].hasError('required') && (signUpForm.controls['email'].touched || signUpForm.controls['email'].dirty)) {
          <div
            class="error">{{'login.thisfieldisrequired' | translate}}
          </div>
        }
      </div>
      <div class="input-box input-box-with-icon">
        <input type="password" formControlName="password" placeholder="{{'login.Password' | translate}}" />
        <span class="input-box-icon-container">
          <img class="input-box-icon" src="assets/images/lock.png" alt="" />
        </span>
        @if (signUpForm.controls['password'].hasError('required') && (signUpForm.controls['password'].touched || signUpForm.controls['password'].dirty)) {
          <div
            class="error">{{'login.thisfieldisrequired' | translate}}
          </div>
        }
      </div>
      <div class="checkbox-container">
        <label class="mdl-checkbox" for="terms">
          <input type="checkbox" formControlName="terms" name="terms1" class="mdl-checkbox__box-outline ">
          <span class="mdl-checkbox__label">{{'login.Iagreetothe' | translate}}
            <a class="terms" href="{{getTerms()}}" target="_blank">{{'login.Termsofuse' | translate}}</a>
            {{'login.and' | translate}} <a class="terms" href="{{getPolicy()}}" target="_blank">{{'login.Privacypolicy'
          | translate}}</a></span>
          @if (signUpForm.controls['terms'].hasError('required') && (signUpForm.controls['terms'].touched || signUpForm.controls['password'].touched || signUpForm.controls['password'].dirty)) {
            <div
              class="error">{{'login.Pleaseaccepttheterms' | translate}}
            </div>
          }
        </label>
      </div>
      <div class="button-container">
        <button type="button" (click)="signUpWithGallop();" class="button button-primary">{{'login.SignUp' |
        translate}}</button>
        <button type="button" class="button button-google button-white button-with-static-icon"
          (click)="handleGoogleSignUpCLick()">
          <img src="assets/images/google-icon.png" alt="" />
          {{'login.SignUpwithGoogle' | translate}}
        </button>
      </div>
      <div class="redirect">
        <div>{{'login.Alreadyhaveanaccount' | translate}} <a (click)="handleClickOnSignInLink()"><span
        class="text-primary">{{'login.Signin' | translate}}</span></a></div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #azureOpen let-modal>
  <div class="modal-header1">
    <h5 class="modal-title">
      {{'login.Userlogin' |  translate}}
    </h5>
    <button type="button" class="close" data-dismiss="modal" (click)="onModelCancel1()">
      <i class="material-icons" style="color:#fff;">close</i>
    </button>
  </div>
  <div class="modal-body1">
    {{this.errormsg}}
    @if (this.loaderShow) {
      <div class="" style="margin-top: 30px;">
        <app-loader [spinnerStyle]="true"></app-loader>
      </div>
    }
    <div class="modal-form-button" style="text-align: center;">
    </div>
  </div>
</ng-template>

<ng-template #createPasswordModal let-modal>
  <!-- Close Button -->
  <button type="button" class="modal-close-btn" (click)="onModelCancel()">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- Icon -->
  <div class="forgot-password-icon">
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="30" fill="url(#forgotPasswordGradient)" opacity="0.1"/>
      <path d="M44 24H20C18.3431 24 17 25.3431 17 27V37C17 38.6569 18.3431 40 20 40H44C45.6569 40 47 38.6569 47 37V27C47 25.3431 45.6569 24 44 24Z" stroke="url(#forgotPasswordGradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 27L32 35L47 27" stroke="url(#forgotPasswordGradient)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <defs>
        <linearGradient id="forgotPasswordGradient" x1="17" y1="24" x2="47" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#8A27F7"/>
          <stop offset="1" stop-color="#315EF6"/>
        </linearGradient>
      </defs>
    </svg>
  </div>

  <!-- Title & Description -->
  <h2 class="forgot-password-title">{{'login.Forgotpassword' | translate}}</h2>
  <p class="forgot-password-description">{{'login.Enteryouremailaddresstoresetyourpassword' | translate}}</p>

  <!-- Form -->
  <form [formGroup]="addEmailForPassword" (keyup.enter)="requestResetPasswordLink()" class="forgot-password-form">
    <!-- Email Input -->
    <div class="forgot-form-group">
      <div class="forgot-input-wrapper">
        <span class="forgot-input-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM16.8 6L10 10.78L3.2 6H16.8ZM2 14V6.91L9.68 12.25C9.77344 12.3172 9.88534 12.3531 10 12.3531C10.1147 12.3531 10.2266 12.3172 10.32 12.25L18 6.91V14H2Z" fill="currentColor"/>
          </svg>
        </span>
        <input
          type="email"
          name="email"
          maxlength="50"
          formControlName="email"
          class="forgot-form-input"
          placeholder="{{'login.Email' | translate}}"
          autocomplete="email"
          />
      </div>
      @if (addEmailForPassword.controls['email'].hasError('pattern') && (addEmailForPassword.controls['email'].touched || addEmailForPassword.controls['email'].dirty)) {
        <div
          class="forgot-error-text">
          {{'login.pleaseenteravalidemail' | translate}}
        </div>
      }
      @if (addEmailForPassword.controls['email'].hasError('required') && (addEmailForPassword.controls['email'].touched || addEmailForPassword.controls['email'].dirty)) {
        <div
          class="forgot-error-text">
          {{'login.thisfieldisrequired' | translate}}
        </div>
      }
    </div>

    <!-- Submit Button -->
    @if (!this.loginService.isRequestInProgress) {
      <button
        type="button"
        (click)="requestResetPasswordLink()"
        class="forgot-btn-submit">
        {{'login.Submit' | translate}}
      </button>
    }
    @if (this.loginService.isRequestInProgress) {
      <button
        type="button"
        class="forgot-btn-submit forgot-btn-loading">
        <span>{{'profilePreference.PleaseWait' | translate}}</span>
        <loader-dots class="forgot-loader"></loader-dots>
      </button>
    }
  </form>
</ng-template>
